import "./hero-slider.scss";

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//
import 'swiper/css/bundle';
import Swiper, { Pagination, EffectCreative } from 'swiper/core';

const heroSlider = () => {
    let heroSliderAll = document.querySelectorAll('.im-hero-slider .swiper-container');
    if(!heroSliderAll.length) return;
    
    heroSliderAll.forEach(el => {

        let slides = el.querySelectorAll('.swiper-slide');
        let loop = true;

        if (slides.length <= 1)
        {
            loop = false;
        }
        
        let arrowPrev = el.querySelector('.swiper-button-prev');
        let arrowNext = el.querySelector('.swiper-button-next');

        let pagination = el.querySelector('.swiper-pagination');

        let typePagination = 'bullets';

        if (pagination)
        {
            switch (true) {
                case pagination.classList.contains('bullets'):
                    typePagination = 'bullets';
                    break;
                case pagination.classList.contains('fraction'):
                    typePagination = 'fraction';
                    break;
                case pagination.classList.contains('progressbar'):
                    typePagination = 'progressbar';
                    break;
                default:
                    typePagination = 'bullets';
                    break;
            }
        }

        let args = {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: loop,
            effect: "creative",
            speed: 600,
            creativeEffect:
            {
                prev:
                {
                    // will set `translateZ(-400px)` on previous slides
                    translate: [0, 0, -500],
                    opacity: 0
                },
                next:
                {
                    // will set `translateX(100%)` on next slides
                    translate: ['100%', 0, 0],
                },
            },
            navigation: 
            {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            pagination:
            {
                el: pagination,
                clickable: true,
                type: typePagination,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        };

        new Swiper(el, args);
    })
}

export default heroSlider;